<template lang="pug">
  div
    Password(
      :error-messages="errors.password",
      :label="$t('form.profile.password.password')",
      :value.sync="model.password",
      @update:value="clearError('password')",
    )
    Password(
      :error-messages="errors.password_confirmation",
      :label="$t('form.profile.password.confirm_password')",
      :value.sync="model.password_confirmation",
      @update:value="clearError('password_confirmation')",
    )
    v-row(no-gutters)
      .flex-grow-1
      v-btn.mt-4(
        @click="submit",
        color="primary",
        :disabled="hasError || !valid",
        :loading="isLoading",
        :ripple="false"
      ) {{ $t("form.profile.password.update") }}
</template>

<script>
import { formHelper } from '@/config/mixins';

export default {
  props: {
    submitFn: {
      type: Function,
      required: true,
    },

    redirectRoute: {
      type: Object,
      required: true,
    },
  },

  mixins: [formHelper],

  methods: {
    submit() {
      if (this.validate()) {
        this.wrapProgress(() =>
          this.submitFn(this.model)
            .then(() => this.$router.push(this.redirectRoute))
            .catch(this.setError),
        );
      }
    },
  },
};
</script>
